"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var languageDisplayNameMapper = {
  en: 'English',
  es: 'Spanish'
};
var LanguageToggle = function LanguageToggle(_ref) {
  var languages = _ref.languages,
    errors = _ref.errors,
    currLang = _ref.currLang,
    setLang = _ref.setLang;
  var isOtherLangError = false;
  var languageToggles = languages.map(function (lang) {
    var isError = lang === 'en' ? (errors === null || errors === void 0 ? void 0 : errors.subject) || (errors === null || errors === void 0 ? void 0 : errors.outroLines) || (errors === null || errors === void 0 ? void 0 : errors.actionText) || (errors === null || errors === void 0 ? void 0 : errors.actionUrl) || (errors === null || errors === void 0 ? void 0 : errors.body) : lang in errors && Object.keys(errors[lang]).length > 0;
    if (isError && lang !== currLang) {
      isOtherLangError = true;
    }
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: lang,
      type: "button",
      className: "nav-item"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: (0, _classnames["default"])('nav-link', currLang === lang && 'active', isError && _style["default"].errorTab),
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        setLang(lang);
      }
    }, lang in languageDisplayNameMapper ? languageDisplayNameMapper[lang] : lang, isError && /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-danger"
    }, "*")));
  });
  return languages.length > 1 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "nav nav-tabs mb-4"
  }, languageToggles), isOtherLangError && /*#__PURE__*/_react["default"].createElement("div", {
    className: "badge text-bg-danger d-block ".concat(_style["default"].otherLangError)
  }, "Errors in other languages"));
};
var _default = exports["default"] = LanguageToggle;